import React from "react";
import "./Contact.css";

export const Contact = () => {
  return <div className="contactcontainer">
    <div className="">
        <div className="contact">
          <h1>Meevärk OÜ</h1>
          <p><b>Registrikood:</b> 14915737</p>
          <p><b>Aadress:</b> Ees-Sarapiku/1, Rahkla küla, Vinni vald, Lääne-Virumaa, 46503</p>
          <p><b>E-mail:</b> info@meevark.ee</p>
          <p><b>Mesinik Urmas Reimann:</b> +372 520 4014</p>
        </div>
    </div>
    <p></p>
  </div>
};